import { render, staticRenderFns } from "./AccordionEventNav.vue?vue&type=template&id=511741c6"
import script from "./AccordionEventNav.vue?vue&type=script&lang=js"
export * from "./AccordionEventNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports